// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"coupon-button-component_uk-open__kmlww","grecaptcha-badge":"coupon-button-component_grecaptcha-badge__1YnVJ","coupon":"coupon-button-component_coupon__SCDUL","noIcon":"coupon-button-component_noIcon__FjFfd","icon":"coupon-button-component_icon__LRjf5","copied":"coupon-button-component_copied__eqVYo"};
    if(module.hot) {
      // 1793877060200
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  